const { runtimeEnvironment } = window;
if (!runtimeEnvironment) {
  throw Error("No runtimeEnvironment");
}

export { runtimeEnvironment };

// File replacement does not work for assets files.
// Assets files cannot be copied, only dirs can.
// In order to expose only one, final asset file, each file should be in a separate folder.
// Final asset file would be imported within the index.html.
